import type { LucideIcon } from 'lucide-react';

interface StepHeaderProps {
  icon: LucideIcon;
  title: string;
  description?: string;
}

/**
 * Standard step header with icon-in-circle + title + optional description.
 * Used at the top of every wizard step.
 */
export function StepHeader({ icon: Icon, title, description }: StepHeaderProps) {
  return (
    <div className="text-center mb-8">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
        <Icon className="h-8 w-8 text-primary" />
      </div>
      <h2 className="text-2xl font-semibold tracking-tight mb-2">
        {title}
      </h2>
      {description && (
        <p className="text-muted-foreground max-w-md mx-auto">
          {description}
        </p>
      )}
    </div>
  );
}
